import { DialogEnums } from "models/enums";
import MessageDialog from "./_messageDialog";
import ContentDialog from "./_contentDialog";
import TabContentDialog from "./_tabContentDialog";
import FullScreenDialog from "./_fullscreenDialog";
import WalkingManDialog from "./_walkingManDialog";
import SelectionDialog from "./_selectionDialog";
import SimpleDialog from "./_simpleDialog";
import BankIdSignDialog from "./_bankIdSignDialog";
import WizardDialogWrapper from "./_wizardDialogWrapper";
import ImageZoomDialog from "./_imageZoomDialog";
import FullScreenNoSpeedDialDialog from "./_fullscreenNoSpeedDialDialog";

export const dialogComponents = {
  [DialogEnums.DialogType.Message]: MessageDialog,
  [DialogEnums.DialogType.Content]: ContentDialog,
  [DialogEnums.DialogType.TabContent]: TabContentDialog,
  [DialogEnums.DialogType.FullScreen]: FullScreenDialog,
  [DialogEnums.DialogType.FullScreenNoSpeedDial]: FullScreenNoSpeedDialDialog,
  [DialogEnums.DialogType.ImageZoom]: ImageZoomDialog,
  [DialogEnums.DialogType.WalkingMan]: WalkingManDialog,
  [DialogEnums.DialogType.Selection]: SelectionDialog,
  [DialogEnums.DialogType.Simple]: SimpleDialog,
  [DialogEnums.DialogType.BankIdSign]: BankIdSignDialog,
  [DialogEnums.DialogType.Wizard]: WizardDialogWrapper,
};
